export default {
  appointments                  : state => state.appointments,
  appointmentsAppearance        : state => state.appointmentsAppearance,
  appointmentsLoading           : state => state.appointmentsLoading,
  appointmentsHistory           : state => state.appointmentsHistory,
  appointmentsHistoryAppearance : state => state.appointmentsHistoryAppearance,
  appointmentsHistoryLoading    : state => state.appointmentsHistoryLoading,
}
